var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconServer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 1.16669H2.33335C1.68902 1.16669 1.16669 1.68902 1.16669 2.33335V4.66669C1.16669 5.31102 1.68902 5.83335 2.33335 5.83335H11.6667C12.311 5.83335 12.8334 5.31102 12.8334 4.66669V2.33335C12.8334 1.68902 12.311 1.16669 11.6667 1.16669Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 8.16669H2.33335C1.68902 8.16669 1.16669 8.68902 1.16669 9.33335V11.6667C1.16669 12.311 1.68902 12.8334 2.33335 12.8334H11.6667C12.311 12.8334 12.8334 12.311 12.8334 11.6667V9.33335C12.8334 8.68902 12.311 8.16669 11.6667 8.16669Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 3.5H3.50583",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 10.5H3.50583",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconServer);
export default __webpack_public_path__ + "static/media/icon-server.4e59324fcab34b4b9dd14b31bbb808dc.svg";
export { ForwardRef as ReactComponent };